import React, { useCallback } from "react";

import ModalManager from "../../../components/common/modal/ModalManager";

const styles = {
  wrap: {
    background: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    padding: "24px",
  },
  header: {
    marginBottom: "20px",
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  description: {
    marginTop: "8px",
    color: "#607284",
    fontSize: "14px",
    lineHeight: 1.6,
  },
  warningCard: {
    border: "1px solid rgba(127, 29, 29, 0.15)",
    background: "rgba(254, 242, 242, 0.8)",
    borderRadius: 8,
    padding: "18px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  warningTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: 600,
    color: "#991b1b",
  },
  warningCopy: {
    margin: 0,
    fontSize: "14px",
    color: "#7f1d1d",
    lineHeight: 1.6,
  },
};

export default function DeviceConfigurationUnpair({ section, unpair }) {
  const handleUnpair = useCallback(() => {
    ModalManager.confirm(
      "This action will unpair the PDU from your account. You can pair the PDU again by logging in directly to the PDU.",
      "Unpair PDU",
      "Confirm",
      (submitted, close) => {
        if (!submitted) {
          return;
        }
        unpair?.(() => {
          if (typeof close === "function") {
            close();
          }
        });
      },
    );
  }, [unpair]);

  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <h4 style={styles.title}>{section?.label || "Unpair"}</h4>
        {section?.description ? (
          <p style={styles.description}>{section.description}</p>
        ) : null}
      </div>

      <div style={styles.warningCard}>
        <h5 style={styles.warningTitle}>Remove this device from Synaccess Cloud</h5>
        <p style={styles.warningCopy}>
          Unpairing removes this PDU from your account. You can pair it again
          later by logging in directly to the device.
        </p>
        <div>
          <button
            type="button"
            className="button"
            style={{ backgroundColor: "maroon", marginBottom: 0 }}
            onClick={handleUnpair}
          >
            Unpair Now
          </button>
        </div>
      </div>
    </div>
  );
}
